"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "TermFilter", {
  enumerable: true,
  get: function get() {
    return _TermFilter["default"];
  }
});
Object.defineProperty(exports, "RangeFilter", {
  enumerable: true,
  get: function get() {
    return _RangeFilter["default"];
  }
});
Object.defineProperty(exports, "BooleanFilter", {
  enumerable: true,
  get: function get() {
    return _BooleanFilter["default"];
  }
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _TermFilter = _interopRequireDefault(require("./TermFilter"));

var _RangeFilter = _interopRequireDefault(require("./RangeFilter"));

var _BooleanFilter = _interopRequireDefault(require("./BooleanFilter"));

var _ExtendedMappingProvider = _interopRequireDefault(require("../../utils/ExtendedMappingProvider"));

var _api = _interopRequireDefault(require("../../utils/api"));

var _config = require("../../utils/config");

var _common = require("./common");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var FieldOpModifier = function FieldOpModifier(_ref) {
  var sqonPath = _ref.sqonPath,
      initialSqon = _ref.initialSqon,
      onSubmit = _ref.onSubmit,
      onCancel = _ref.onCancel,
      fieldDisplayNameMap = _ref.fieldDisplayNameMap,
      opDisplayNameMap = _ref.opDisplayNameMap,
      _ref$ContainerCompone = _ref.ContainerComponent,
      ContainerComponent = _ref$ContainerCompone === void 0 ? _common.FilterContainer : _ref$ContainerCompone,
      _ref$api = _ref.api,
      api = _ref$api === void 0 ? _api["default"] : _ref$api,
      field = _ref.field,
      _ref$arrangerProjectI = _ref.arrangerProjectId,
      arrangerProjectId = _ref$arrangerProjectI === void 0 ? _config.PROJECT_ID : _ref$arrangerProjectI,
      arrangerProjectIndex = _ref.arrangerProjectIndex,
      _ref$getExecutableSqo = _ref.getExecutableSqon,
      getExecutableSqon = _ref$getExecutableSqo === void 0 ? function () {
    return initialSqon;
  } : _ref$getExecutableSqo;
  return /*#__PURE__*/_react["default"].createElement(_ExtendedMappingProvider["default"], {
    api: api,
    projectId: arrangerProjectId,
    graphqlField: arrangerProjectIndex,
    field: field
  }, function (_ref2) {
    var loading = _ref2.loading,
        extendedMapping = _ref2.extendedMapping;
    var fieldExtendedMapping = (extendedMapping || []).find(function (_ref3) {
      var _field = _ref3.field;
      return field === _field;
    }); // temporary, needs to handle errors too

    console.log('fieldExtendedMapping: ', fieldExtendedMapping);

    var _ref4 = fieldExtendedMapping || {},
        type = _ref4.type,
        unit = _ref4.unit;

    return ['id', 'keyword', 'string', 'text'].includes(type) ? /*#__PURE__*/_react["default"].createElement(_TermFilter["default"], {
      field: field,
      arrangerProjectId: arrangerProjectId,
      arrangerProjectIndex: arrangerProjectIndex,
      api: api,
      loading: loading,
      sqonPath: sqonPath,
      initialSqon: initialSqon,
      executableSqon: getExecutableSqon(),
      onSubmit: onSubmit,
      onCancel: onCancel,
      fieldDisplayNameMap: fieldDisplayNameMap,
      opDisplayNameMap: opDisplayNameMap,
      ContainerComponent: ContainerComponent
    }) : ['byte', 'date', 'float', 'half_float', 'integer', 'long', 'scaled_float', 'unsigned_long'].includes(type) ? /*#__PURE__*/_react["default"].createElement(_RangeFilter["default"], {
      field: field,
      loading: loading,
      sqonPath: sqonPath,
      initialSqon: initialSqon,
      executableSqon: getExecutableSqon(),
      onSubmit: onSubmit,
      onCancel: onCancel,
      fieldDisplayNameMap: fieldDisplayNameMap,
      opDisplayNameMap: opDisplayNameMap,
      ContainerComponent: ContainerComponent,
      unit: unit
    }) : ['boolean'].includes(type) ? /*#__PURE__*/_react["default"].createElement(_BooleanFilter["default"], {
      field: field,
      api: api,
      arrangerProjectId: arrangerProjectId,
      arrangerProjectIndex: arrangerProjectIndex,
      sqonPath: sqonPath,
      initialSqon: initialSqon,
      executableSqon: getExecutableSqon(),
      onSubmit: onSubmit,
      onCancel: onCancel,
      fieldDisplayNameMap: fieldDisplayNameMap,
      opDisplayNameMap: opDisplayNameMap,
      ContainerComponent: ContainerComponent
    }) : /*#__PURE__*/_react["default"].createElement(ContainerComponent, {
      onSubmit: onSubmit,
      onCancel: onCancel
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "unhandledFieldType"
    }, "Unhandled field type: ", type));
  });
};

FieldOpModifier.prototype = {
  sqonPath: _propTypes["default"].arrayOf(_propTypes["default"].number),
  initialSqon: _propTypes["default"].object,
  onSubmit: _propTypes["default"].func,
  onCancel: _propTypes["default"].func,
  fieldDisplayNameMap: _propTypes["default"].objectOf(_propTypes["default"].string),
  opDisplayNameMap: _propTypes["default"].objectOf(_propTypes["default"].string),
  ContainerComponent: _propTypes["default"].any,
  api: _propTypes["default"].func,
  field: _propTypes["default"].string,
  arrangerProjectId: _propTypes["default"].string,
  arrangerProjectIndex: _propTypes["default"].string.isRequired,
  getExecutableSqon: _propTypes["default"].func
};
var _default = FieldOpModifier;
exports["default"] = _default;